import L from "leaflet";

/** Untitled UI Anchor (viewBox 0 0 24 24) */
const ANCHOR_PATH =
    "M12 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 0v14m0 0A10 10 0 0 1 2 12h3m7 10a10 10 0 0 0 10-10h-3";

/** Untitled UI MarkerPin01 — goccia */
const PIN_DROP_PATH = "M12 22c4-4 8-7.582 8-12a8 8 0 1 0-16 0c0 4.418 4 8 8 12Z";

/** Spunta centrata sulla “testa” del pin (centro ~12,10) */
const ARRIVAL_CHECK_PATH = "M9 10.5 11 12.5 15 8.5";

/** Porto di partenza — ancora su disco chiaro, bordo = colore rotta */
export function createRouteOriginIcon(routeHexColor: string): L.DivIcon {
    const size = 36;
    return L.divIcon({
        html: `
            <div style="width:${size}px;height:${size}px;filter:drop-shadow(0 1px 3px rgba(0,0,0,0.4));">
                <svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                    style="display:block;background:rgba(255,255,255,0.94);border-radius:9999px;box-sizing:border-box;border:2px solid ${routeHexColor};">
                    <path d="${ANCHOR_PATH}" stroke="${routeHexColor}" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        `,
        className: "world-map-route-endpoint world-map-route-endpoint--origin",
        iconSize: [size, size],
        iconAnchor: [size / 2, size / 2],
    });
}

/**
 * Porto di destinazione — pin pieno (colore rotta) + spunta bianca = arrivo.
 * Ancora sulla punta del pin (y≈22 in viewBox 24).
 */
export function createRouteDestinationArrivalIcon(routeHexColor: string): L.DivIcon {
    const w = 36;
    const h = 44;
    const tipY = Math.round((22 / 24) * h);
    return L.divIcon({
        html: `
            <div style="width:${w}px;height:${h}px;filter:drop-shadow(0 2px 4px rgba(0,0,0,0.45));">
                <svg width="${w}" height="${h}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="display:block;">
                    <path d="${PIN_DROP_PATH}" fill="${routeHexColor}" stroke="rgba(255,255,255,0.95)" stroke-width="1.35" stroke-linejoin="round"/>
                    <path d="${ARRIVAL_CHECK_PATH}" stroke="rgba(255,255,255,0.98)" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        `,
        className: "world-map-route-endpoint world-map-route-endpoint--destination",
        iconSize: [w, h],
        iconAnchor: [w / 2, tipY],
    });
}
